// src/pages/Blog.jsx
import React from 'react';
import BlogPost from '../components/BlogPost';

const Blog = () => {
  return (
    <div className="blog-page">
      <BlogPost />
    </div>
  );
};

export default Blog;